import React from 'react';
import { motion } from 'framer-motion';

const Slide06Science: React.FC = () => {
  const research = [
    {
      title: "Bloom's 2 Sigma Effect",
      description: 'Personalised mastery learning improves outcomes by 2 standard deviations',
      color: '#3b82f6',
    },
    {
      title: "Hattie's Formative Feedback",
      description: 'Real-time feedback has an effect size of d=0.7 on learning outcomes',
      color: '#10b981',
    },
    {
      title: 'Spaced Repetition',
      description: 'Ebbinghaus forgetting curve modelling for optimal review timing',
      color: '#8b5cf6',
    },
    {
      title: 'Zone of Proximal Development',
      description: "Vygotsky's theory: AI maintains optimal challenge with scaffolded hints",
      color: '#ec4899',
    },
  ];

  return (
    <div className="flex flex-col items-center justify-center h-full px-16">
      <motion.h2
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        className="text-5xl font-bold text-white mb-4 text-center"
      >
        Built on Learning Science
      </motion.h2>
      <motion.p
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.2 }}
        className="text-2xl text-[#94a3b8] mb-12 text-center"
      >
        Every feature is grounded in peer-reviewed educational research
      </motion.p>

      <div className="grid grid-cols-2 gap-8 max-w-4xl">
        {research.map((item, index) => (
          <motion.div
            key={item.title}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4, delay: 0.3 + index * 0.1 }}
            className="flex items-start gap-4 p-5 rounded-xl"
            style={{
              background: `linear-gradient(135deg, ${item.color}15 0%, transparent 100%)`,
              border: `1px solid ${item.color}40`,
            }}
          >
            <div
              className="w-3 h-3 rounded-full mt-2 flex-shrink-0"
              style={{ background: item.color }}
            />
            <div>
              <h3 className="text-xl font-semibold text-white mb-2">{item.title}</h3>
              <p className="text-lg text-[#94a3b8]">{item.description}</p>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default Slide06Science;
